/* eslint-disable class-methods-use-this */
import React, { Component } from "react";
import PropTypes from "prop-types";

class Paginator extends Component {
  constructor(props) {
    super(props);
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  getLinkProps(page, disabled) {
    const { indexFirstPageOnly } = this.props;
    return {
      href: (!disabled && this.props.getLink(page)) || "javascript:void(0)",
      "aria-disabled": disabled,
      rel: indexFirstPageOnly && page !== 1 ? "noindex" : "",
      onClick: disabled
        ? undefined
        : e => {
            this.props.onPageChange(page);
            this.props.onPageLinkClick(e);
          },
    };
  }

  tolalPageLte7(pageNow, totalPage) {
    const pageArr = [];
    for (let page = 1; page <= totalPage; page++) {
      pageArr.push({
        page,
        active: page === pageNow,
      });
    }
    return pageArr;
  }

  curPageLte4(pageNow, totalPage) {
    const pageArr = [];
    for (let page = 1; page <= 6; page++) {
      pageArr.push({
        page,
        active: page === pageNow,
      });
    }
    pageArr.push({
      page: "...",
      dot: true,
      active: false,
    });
    pageArr.push({
      page: totalPage,
      active: false,
    });
    return pageArr;
  }

  curPageGt4(pageNow, totalPage) {
    const pageArr = [];
    pageArr.push({
      page: 1,
      active: false,
    });
    pageArr.push({
      page: "...",
      dot: true,
      active: false,
    });
    if (totalPage - pageNow >= 3) {
      for (let page = pageNow - 2; page <= pageNow; page++) {
        pageArr.push({
          page,
          active: page === pageNow,
        });
      }
    } else {
      for (let page = pageNow - (5 - (totalPage - pageNow)); page <= pageNow; page++) {
        pageArr.push({
          page,
          active: page === pageNow,
        });
      }
    }
    return pageArr;
  }

  handlePageClick(event) {
    event.preventDefault();
    const target = event.target;
    if (target.tagName !== "A" || /active|page-prev|page-next/g.test(target.className)) {
      return false;
    }
    const page = parseInt(target.innerHTML, 10);
    if (isNaN(page)) {
      return false;
    }
    this.props.onPageChange(page);
    return true;
  }

  renderPages(pageNow, totalPage) {
    let pageArr = [];
    if (totalPage <= 7) {
      pageArr = this.tolalPageLte7(pageNow, totalPage);
    } else if (pageNow <= 4) {
      pageArr = this.curPageLte4(pageNow, totalPage);
    } else {
      pageArr = this.curPageGt4(pageNow, totalPage);
      if (pageNow + 3 >= totalPage) {
        for (let page = pageNow + 1; page <= totalPage; page++) {
          pageArr.push({
            page,
            active: false,
          });
        }
      } else {
        for (let page = pageNow + 1; page <= pageNow + 2; page++) {
          pageArr.push({
            page,
            active: false,
          });
        }
        pageArr.push({
          dot: true,
          active: false,
        });
        pageArr.push({
          page: totalPage,
          active: false,
        });
      }
    }
    return pageArr.map(item => {
      if (item.dot) {
        return (
          <li className="page-item page-dot" key={`page-item-${item.page}`}>
            ...
          </li>
        );
      }
      return (
        <li className={`page-item ${item.active ? "active" : ""}`} key={`page-item-${item.page}`}>
          <a className="page-link" {...this.getLinkProps(item.page)}>
            {item.page}
          </a>
        </li>
      );
    });
  }

  renderPrev(pageNow) {
    const disabled = pageNow === 1;
    const prevClass = disabled ? "disabled" : "";
    return (
      <li className="page-item">
        <a
          {...this.getLinkProps(pageNow - 1, disabled)}
          className={`page-link page-prev ${prevClass}`}
          aria-label="Previous"
        >
          上一页
        </a>
      </li>
    );
  }

  renderNext(pageNow, totalPage) {
    const disabled = pageNow >= totalPage;
    const nextClass = disabled ? "disabled" : "";
    return (
      <li className="page-item">
        <a
          {...this.getLinkProps(pageNow + 1, disabled)}
          className={`page-link page-next ${nextClass}`}
          aria-label="Next"
        >
          下一页
        </a>
      </li>
    );
  }

  render() {
    const totalPage = this.props.totalPage;
    const pageNow = this.props.pageNow || 1;
    if (totalPage === 0) {
      return null;
    }
    return (
      <ul className="phx-paginator-wrapper">
        {totalPage > 1 ? this.renderPrev(pageNow, totalPage) : null}
        {this.renderPages(pageNow, totalPage)}
        {totalPage > 1 ? this.renderNext(pageNow, totalPage) : null}
      </ul>
    );
  }
}

Paginator.defaultProps = {
  pageNow: 1,
  indexFirstPageOnly: true,
  onPageChange() {},
  onPageLinkClick() {},
  getLink() {},
};

const { number, func } = PropTypes;

Paginator.propTypes = {
  totalPage: number.isRequired, // 总页数
  pageNow: number, // 当前页
  onPageChange: func, // 切换页数时调用
  getLink: func,
  indexFirstPageOnly: PropTypes.bool,
  onPageLinkClick: PropTypes.func,
};

export default Paginator;

require("./index.less");
require("./index.less");